import http from "@/utils/http";
import exam_enum from "../../utils/exam_enum";
import { networkData } from "../../utils/data";
import scorePermissionEnum from "@/utils/enums/scorePermissionEnum";
import util from "../../utils/util";

// 单科考试
export const getExamClassList = (params) => http.get(`/marking-exam-manager/exam_class/list/exam-id/${params.examId}/school-id/${params.schoolId}`) // 获取带权限的考试班级
// 获取单场考试
export const getExam = (examId) => http.get(`/marking-exam-manager/exam-list/${examId}`).then(resp => {
  if (resp && resp.body) {
    const examIds = []
    resp.body.forEach(item => {
      examIds.push(item.id)
      item.type = exam_enum.getCodeByKey(item.type)
      item.hasPaper = exam_enum.getCodeByKey(item.hasPaper)
      item.hasStand = exam_enum.getCodeByKey(item.hasStand)
      item.isMore = exam_enum.getCodeByKey(item.isMore)
      item.schoolType = exam_enum.getCodeByKey(item.schoolType)
      item.examSchools.forEach(school => {
        school.school = item.sysSchools.find(s => s.id === school.schoolId)
        school.examSign = exam_enum.getCodeByKey(school.detailStatus)
      })
      item.reportNum = item.examSchools.filter(s => s.examSign === 2).length
      item.schoolNum = item.schoolIds.length
      item.subject = {
        dicCode: item.subjectCode,
        dicName: item.subjectName,
      }
      item.teamLeaders = networkData.formatTeachers(item.teachers);
      item.teamLeaderIds = item.teachers.map(t => t.id)
      item.examSign = item.reportState && exam_enum.getCodeByKey(item.reportState.examSign) === 1
      item.scorePermission = util.getEnumCodeByKey(scorePermissionEnum, item.scorePermission)

      item.importType = exam_enum.getCodeByKey(item.importType)
    })

    let examData = resp.body[0]
    // 如果存在二卷
    if (resp.body.length > 1) {
      const twoPaper = resp.body[1]
      examData.twoIsHen = twoPaper.isHen
      examData.twoTeamLeaders = twoPaper.examSchools ? twoPaper.examSchools[0].teamLeaderId.split(',') : ''
    }

    examData.examIds = examIds
    resp.body = examData
  }
  return resp
})

// 获取批阅进度
export const getReviewProgress = (params) => http.post('/marking-statistics/exam/long-task/examIds', params) // 获取批阅进度

export const getOnlineExam = (params) => http.get('/marking-exam-manager/exam-list/single/' + params.examId) // 获取单场考试
export const getExamStudentList = (params) => http.post(`/marking-exam-manager/exam/${params.examId}/doubt/student/search?maxCount=${params.pageSize}`, params) // 获取考试学生
export const createSingleExam = (params) => http.post('/marking-exam-manager/exam-base', params) // 创建考试
export const updateSingleExam = (params) => http.put(`/marking-exam-manager/exam-list/${params.id}`, params, 'json') // 更新考试
export const getRefreshNum = (params) => http.post('/marking-main/exam/exam/refresh_num', params) // 诊断 识别成功数量查询

export const clearExam = (params) => http.delete('/marking-exam-manager/exam-list/clear_data', params, 'json') // 删除考试
export const deleteExam = (examId) => http.delete(`/marking-exam-manager/exam-list/${examId}`) // 删除考试
export const createExamTemp = (params) => http.post('/marking-main/exam/exam/set/temp', params) // 添加考试模板
export const updateExamTemp = (params) => http.post('/marking-main/exam/exam/update_temp', params) // 更新考试模板
export const getExamTemp = (params) => http.post('/marking-main/exam/exam/get/temp', params) // 获取考试模板
export const checkExamCode = (params) => http.post('/marking-main/exam/exam/check_code', params) // 校验考试编号是否存在
export const setScoreType = (params) => http.put(`/marking-exam-manager/exam-list/${params.examId}/score-flag/${params.scoreFlag}`) // 设置阅卷方式
export const joinExam = (params) => http.post('/marking-main/exam/exam/pass/add', params) // 通过密码添加考试
export const getExamPass = (params) => http.post('/marking-main/exam/exam/pass/get', params, 'form') // 通过密码获取考试
export const getExamParam = (params) => http.get('/marking-statistics/exam-param', params) // 获取考试参数
export const updateExamParam = (params) => http.put('/marking-statistics/exam-param', params) // 更新考试参数
export const getExamAnalysis = (params) => http.post('/marking-main/exam/doubt/get/report', params) // 获取预警分析
export const setOnlineQuestion = (params) => http.put('/marking-exam-manager/exam-online/stand', params) // 在线考试设置题目
export const getOnlineQuestion = (params) => http.get('/marking-main/exam/exam/get_online_question', params, 'form') // 在线考试获取题目
export const setOnlineTime = (params) => http.post('/marking-main/exam/exam/set_online_time', params) // 在线考试设置时间
export const forceEndOnlineExam = (params) => http.post('/marking-minipro/exam/student/forceEndOnlineExam', params, 'form') // 强制交卷
export const listOnlineStatus = (params) => http.post('/marking-main/exam/exam/list_online_status', params) // 获取状态列表
export const delayedExamResutTime = (params) => http.post('/marking-main/exam/exam/delayedExamResutTime', params, 'form') // 延长考试时间
export const createBatchExam = (params) => http.post(`/marking-exam-manager/exam-base/batch`, params)// 批量创建考试
export const paperPdfToImg = (params) => http.get('/marking-main/exam/exam/get_paper_pdf_to_img', params) // 设置在线pdf试卷转图片

//多科考试
export const addMultiExam = params =>
  http.post("/marking-statistics/multi-exam?isRegion=false", params); //新增、创建多科考试
//查询、列出多科考试
export const queryMultiExam = params =>
  http.post("/marking-statistics/multi-exam/search?isRegion=false", params).then(resp => {
    if (resp.success && resp.body.items) {
      resp.body.items.forEach(item => {
        item.examBaseVos.forEach(element => {
          element.scoreFlag = element.scoreFlag ? exam_enum.examEnum[element.scoreFlag].code : 0
          element.typeDesc = exam_enum.getDescByKey(element.type)
          element.standConfirmCode = exam_enum.getCodeByKey(element.standConfirm)
          if (element.reportState) {
            element.reportState.examSign = exam_enum.getCodeByKey(element.reportState.examSign)
            element.reportState.qualitySign = exam_enum.getCodeByKey(element.reportState.qualitySign)
          }
        });
      });
    }
    return resp
  });
export const updateMultiExam = params =>
  http.put(`/marking-statistics/multi-exam/${params.id}?isRegion=false`, params); //编辑、更新多科考试
export const delMultiExam = params =>
  http.delete(`/marking-statistics/multi-exam/${params.examId}`); //删除多科考试
//获取单个多科考试的信息
export const getMultiExamInfo = params =>
  http.get(`/marking-statistics/multi-exam/${params.examId}?isRegion=false`).then(resp => {
    if (resp.success && resp.body.examBaseVos) {
      resp.body.examBaseVos.forEach(element => {
        element.scoreFlag = element.scoreFlag ? exam_enum.examEnum[element.scoreFlag].code : 0
        element.typeDesc = exam_enum.getDescByKey(element.type)
        element.standConfirmCode = exam_enum.getCodeByKey(element.standConfirm)
        if (element.reportState) {
          element.reportState.examSign = exam_enum.getCodeByKey(element.reportState.examSign)
          element.reportState.qualitySign = exam_enum.getCodeByKey(element.reportState.qualitySign)
        }
      });
    }
    return resp
  });
// 检测是否存在多科报告
export const getExistMultiReport = (finalId) => http.get(`/marking-statistics-report/multiple/school/can/look/${finalId}`)

export const getMultiSingleExamList = params =>
  http.post("/marking-main/exam/exam/list_exam", params); // 获取单科行政班考试列表
// 获取单校考试可以选择的班级列表
export const getMoreExamClassList = params => http.get(`/marking-statistics/multi-exam/${params.examId}/class`).then(res => {
  if (res.success && res.body) {
    res.body.forEach(item => {
      if (item.className.charAt(item.className.length - 1) !== "班") {
        item.className += "班"
      }
    })
  }
  return res;
})

// 标准答案
export const getStandAnswer = params =>
  http.get(`/marking-exam-manager/stand/region/${params.examId}`).then(resp => {
    if (resp.success && resp.body.examStandVos) {
      resp.body.examStandVos.forEach(element => {
        element.choiceTypeCode = exam_enum.getCodeByKey(element.choiceType)
      })
    }
    if (resp.body.examBase) {
      resp.body.examBase.importType = exam_enum.getCodeByKey(resp.body.examBase.importType)
      resp.body.examBase.isMore = exam_enum.getCodeByKey(resp.body.examBase.isMore)
    }
    return resp
  });
// 随机获取一个学生的试卷图片作为标准答案
export const getStandAnswerUrl = params =>
  http.put(`/marking-exam-manager/stand/student/${params.examId}`).then(resp => {
    if (resp.success && resp.body.examStandVos) {
      resp.body.examStandVos.forEach(element => {
        element.choiceTypeCode = exam_enum.getCodeByKey(element.choiceType)
      })
    }
    return resp
  });
export const setStandAnswerConfirm = params =>
  http.put(`/marking-exam-manager/stand/region/${params.examId}`, params) // 确认标准答案
export const listOnlineStand = params =>
  http.get(`/marking-exam-manager/stand/online/${params.examId}`, params).then(resp => {
    if (resp.success && resp.body) {
      resp.body.forEach(element => {
        element.choiceTypeCode = exam_enum.getCodeByKey(element.choiceType)
      })
    }
    return resp;
  }); // 获取在线考试的标准答案
export const updateOnlineStand = params =>
  http.put(`/marking-exam-manager/stand/online/${params.examId}`, params.standVos); // 更新在线考试的标准答案

// 考试识别
export const getDistinguishList = params =>
  http.post("/marking-exam-manager/student-paper-statistic/student-paper/search", params).then(resp => {
    if (resp.body.items) {
      resp.body.items = networkData.getIdentifyStudents(resp.body.items)
    }
    return resp
  });
//统计识别tab页
export const getDistinguishCount = params => http.post("/marking-exam-manager/student-paper-statistic/student-paper/count", params).then(resp => {
  if (resp.body) {
    resp.body = networkData.convertIdentificationTabData(resp.body)
  }
  return resp
});
export const setDistinguishExamType = params =>
  http.post("/marking-exam-manager/student-paper-statistic/student-paper/mark", params, 'form'); // 统计识别 标记为缺考免考
export const setDistinguishMark = params =>
  http.post("/marking-exam-manager/student-paper-statistic/student-paper/statistics", params, 'form'); // 统计识别标记
export const delStudentAnswer = params => http.delete(`/marking-exam-manager/student-paper-statistic/paper?force=true`, params, 'form') // 删除学生成绩
// 获取单个识别
export const getDistinguish = params =>
  http.get("/marking-exam-manager/student-paper-statistic/student-score", params).then(resp => {
    if (resp.body) {
      resp.body = networkData.getExamPaperDetails(resp.body)
    }
    return resp
  });
export const updateDistinguish = params =>
  http.put(`/marking-exam-manager/student-paper-statistic/student-score?examId=${params.examId}&schoolId=${params.schoolId}&resultId=${params.resultId}&studentId=${params.studentId}`, params); // 更新单个识别
export const updateDistinguishInput = params =>
  http.post(`/marking-exam-manager/student-paper-statistic/student-score?examId=${params.examId}&schoolId=${params.schoolId}&studId=${params.studId}`, params.details);  // 更新单个录入
export const getDistinguishLogList = params =>
  http.post("/marking-exam-manager/student-paper-statistic/detail_log/search", params); // 获取识别日志列表
export const deleteExamScans = params =>
  http.delete(`/marking-exam-manager/student-paper-statistic/paper/batch?examId=${params.examId}&force=true`, params.studentIds, "json"); // 批量删除识别
export const returnOnlineExamResult = params =>
  http.post("/marking-minipro/online-exam/student/return", params); // 打回重传
export const exportStudent = params => http.post('/marking-exam-manager/student-score/excel/student', params) // 导出未上传、已经上传、缺考、免考、学生的接口


// 疑问项新版
export const getQuestionList = params =>
  http.post(`/marking-exam-manager/exam/${params.examId}/doubt/search`, params);
export const deleteQuestionList = params =>
  http.delete(`/marking-exam-manager/exam/${params.examId}/doubt`, params.doubtIds, "json");
export const updateQuestionList = params =>
  http.put(`/marking-exam-manager/exam/${params.examId}/doubt`, params.doubts);
export const getQuestionCount = params =>
  http.get(`marking-exam-manager/exam/${params.examId}/doubt/num`, params);
export const updateQuestionMarkNo = params =>
  http.put(`/marking-exam-manager/exam/${params.examId}/doubt/${params.doubtId}/mark_not_find_student`);
export const waitDealQuestion = params =>
  http.put(`/marking-exam-manager/exam/${params.examId}/doubt/${params.doubtId}/wait_deal`);
export const getListClassByGrade = params =>
  http.post("/marking-platform/school-class/grade-class", params); //根据年级获取所有班级

export const resetQuestion = params =>
  http.post("/marking-main/exam/doubt/reset_school", params); // 重置疑问项(当前为雪松湾使用)

//制卡考试
export const addSheetExam = params =>
  http.post("/marking-exam-manager/exam-base/sheet-exam", params); // 创建制卡考试
export const listExamTemplate = params =>
  http.post("/marking-exam-manager/sheet-template/list", params); // 查询考试模板
// 获取考试列表
export const listExam = params => http.post('/marking-exam-manager/exam-list/single/search', params).then(resp => {
  if (resp && resp.body) {
    resp.body.items.forEach(item => {
      item.isMore = exam_enum.getCodeByKey(item.isMore)
      item.importType = exam_enum.getCodeByKey(item.importType)
      item.scoreFlagDesc = item.scoreFlag === 0 ? '待选择' : exam_enum.getDescByKey(item.scoreFlag)
      item.scoreFlag = exam_enum.getCodeByKey(item.scoreFlag)
      item.examTypeName = exam_enum.getDescByKey(item.type)
      item.type = exam_enum.getCodeByKey(item.type)
      item.standConfirm = exam_enum.getCodeByKey(item.standConfirm)
      item.hasPaper = exam_enum.getCodeByKey(item.hasPaper)
      item.hasStand = exam_enum.getCodeByKey(item.hasStand)
      item.disSucNum = 0
      if (item.reportState) {
        item.reportState.examSign = exam_enum.getCodeByKey(item.reportState.examSign)
        item.reportState.qualitySign = exam_enum.getCodeByKey(item.reportState.qualitySign)
      }

      if (item.examSchools) {
        item.disSucNum = item.examSchools[0].disSucNum || 0 // 赋值在线考试学生识别数
        item.examSchools.forEach(school => {
          school.isGrading = exam_enum.getCodeByKey(school.isGrading)
        })
      }
    })
  }
  return resp
})

// 拆分考试
export const isSplitSchoolExam = params =>
  http.get(`/marking-exam-manager/split-exam/${params.examId}/can_split`); // 是否允许拆分考试.

// 确认标准答案-新
export const getListAllStand = params =>
  http.get(`/marking-exam-manager/stand/school/${params.examId}`).then(resp => {
    if (resp.success && resp.body) {
      // 转换试题类型
      resp.body.examStandVos.forEach(element => {
        element.choiceTypeCode = exam_enum.getCodeByKey(element.choiceType)
      })

      // 转换类型
      if (resp.body.examBase) {
        resp.body.examBase.typeDesc = exam_enum.getDescByKey(resp.body.examBase.type)
        resp.body.examBase.standConfirmCode = exam_enum.getCodeByKey(resp.body.examBase.standConfirm)
        resp.body.examBase.hasPaper = exam_enum.getCodeByKey(resp.body.examBase.hasPaper)
      }

      // 转换批阅状态
      if (resp.body.gradingStatus == null) {
        resp.body.isGrading = -1
      }
      else if (resp.body.gradingStatus) {
        resp.body.isGrading = exam_enum.getCodeByKey(resp.body.gradingStatus)
      }

      // 转换试题坐标
      resp.body.examStandVos.forEach(element => {
        element.templatePositionList = []
        element.templatePointPositionList = []
        if (resp.body.examStandStates && resp.body.examStandStates.length > 0) {
          resp.body.examStandStates.forEach(template => {
            // 当前模板坐标
            const templatePosition = {
              templateNum: template.templateNum,
              positionList: [],
              optionList: [],
            }

            // 检测是否存在选项坐标
            if (element.etcs) {
              const optionPosition = element.etcs[template.templateNum]
              if (optionPosition) {
                templatePosition.optionList = util.optionCoordinateAnalysis(optionPosition)
              }
            }

            // 检测是否存在框选坐标
            if (element.templatePositions) {
              const position = element.templatePositions[template.templateNum]
              if (position) {
                templatePosition.positionList = util.coordinateListAnalysis(position)
              } else {
                templatePosition.positionList.push([{ x: 10, y: 10, w: 10, h: 10 }])
              }
            }

            if (element.choiceTypeCode === 2) {
              // 当前模板坐标
              const templatePointPosition = {
                templateNum: template.templateNum,
                pointPositionList: [],
              }

              // 检测是否存在登分框坐标
              if (element.templatePointPositions) {
                const position = element.templatePointPositions[template.templateNum]
                if (position) {
                  templatePointPosition.pointPositionList.push({
                    ...util.coordinateAnalysis(position),
                    optionList: templatePosition.optionList
                  })
                }
              }
              element.templatePointPositionList.push(templatePointPosition)
            }
            element.templatePositionList.push(templatePosition)
          })
        }
      });
    }
    return resp
  }); // 获取所有标准答案(模板一和二)
export const getPagePosition = params =>
  http.get('/marking-exam-manager/exam-stand-state/page-positions', params)
export const saveAffirmAllList = params =>
  http.put(`/marking-exam-manager/stand/school/${params.examId}`, params); // 保存所有标准答案(模板一和二)
export const isNewExam = params =>
  http.get(`/marking-exam-manager/stand/is-new-exam/${params.examId}`); // 判断是否进入标准答案新版页面(非制卡或区域就是新版)
export const updateTeaGrading = params =>
  http.post("/marking-main/exam/grad/update_tea_grading", params); // 变更教师批阅
// 获取学生成绩模板
export const getStudentScoreTemp = params => http.get('/marking-exam-manager/student-score/excel/template', params)
// 查询任务进度
export const queryTaskProgress = tempId => http.get(`/marking-platform/long-task/${tempId}`)
// 获取Ocr任务
export const getOcrTask = schoolId => http.get(`/marking-exam-manager/stand/${schoolId}/re_ocr/task`)
// 查询考试评分记录
export const getGradingRecord = (params) => http.get('/marking-exam-grading/grading-record/grading-detail/show-paper', params)
// 获取客观题识别坐标
export const getObjectivePosition = (params) => http.post('/marking-exam-manager/stand/position/objective', params).then(res => {
  if (res.success && !res?.body) {
    return res
  }

  const hasValidSubPositions = Array.isArray(res.body) && res.body.every(item => {
    const subPositions = item?.subPosition || []
    return Array.isArray(subPositions)
  })

  if (!hasValidSubPositions) {
    window.SlsSend({
      action: 'getObjectivePosition',
      desc: '获取客观题识别坐标错误',
      data: res,
      params
    })
  }
  return res
})

// 获取试卷打标信息
export const getMarkingPaperInfo = (params) => http.post('/marking-watermark/result/url/view-paper-watermark', params)
// 发送消息
export const sendMessage = (params) => http.post('/marking-wechat/notify-enterprise-wechat', params)


// 学生答案相关
// 获取学生试卷集合
export const getStudentPaper = (params) => http.post('/marking-exam-manager/student-paper-statistic/student-paper/query', params)
// 批量标记无名卷
export const labelUnnamedVolume = (params) => http.put(`/marking-exam-manager/exam/${params.examId}/doubt/mark_not_find_student/batch`, params.detailIds)
// 删除试卷
export const delStudentPaper = (params) => http.delete(`/marking-exam-manager/student-paper-statistic/delete_paper?examId=${params.examId}${params.url}`, params.resultIds, 'json')
// 是否包含选科筛选
export const getShowChooseSubject = (examId) => http.get(`/marking-exam-manager/student-paper-statistic/${examId}/choose_subject`)

/// 扫描批次相关
// 获取配置参数接口
export const getConfigurationParameter = (params) => http.get(`/marking-exam-manager/scan-batch/config/${params.examId}/${params.schoolId}`)
// 获取批次列表
export const getScanBatchList = (params) => http.post('/marking-exam-manager/scan-batch/list', params)
// 获取考试扫描进度
export const getScanProgress = (params) => http.get(`/marking-exam-manager/scan-batch/progress/${params.examId}/${params.schoolId}`)
// 根据批次获取原卷列表
export const getScanBatchPaperList = (params) => http.post('/marking-exam-manager/scan-batch/paper/list', params)
// 删除扫描原卷
export const delScanBatchPaper = (params) => http.delete(`/marking-exam-manager/scan-batch/paper/delete/ids`, params, 'json')
// 删除扫描批次
export const delScanBatch = (batchId) => http.delete(`/marking-exam-manager/scan-batch/${batchId}`)
// 恢复识别
export const recoverScan = (examId, ids) => http.put(`/marking-exam-manager/scan-batch/paper/recover?examId=${examId}`, ids)
